export const dataLayer = (event, data, isEcommerce = true) => {
  window.dataLayer = window.dataLayer || [];

  isEcommerce && window.dataLayer.push({ ecommerce: null });

  window.dataLayer.push({ event: event, ...data });
};
